<ng-template #steps>
  <div class="d-flex flex-column justify-center text-center">
    <h1 class="mb-0" [translate]="processTitle()"></h1>
  </div>

  @if (stepsTitle()) {
    <div class="d-flex flex-column justify-center text-center mb-3">
      <ng-content />
    </div>
    <div class="d-flex flex-column justify-left text-left mb-3">
      <h2 class="h4" [translate]="stepsTitle()"></h2>
    </div>
  }
  <mwe-timeline [showLine]="true">
    @for (item of formattedSteps(); track $index) {
      <li mwetimelineitem>
        <h3 class="h4" [innerHTML]="item.title | translate: item.translationParams"></h3>
        @for (label of item.label; track $index) {
          <p class="text-break" [innerHTML]="label | translate: item.translationParams | safeHtml"></p>
        }
      </li>
    }
  </mwe-timeline>
</ng-template>
@if (asCard()) {
  @if (formattedSteps()?.length) {
    <mwe-basic-card class="d-block mb-4">
      <ng-container *ngTemplateOutlet="steps" />
    </mwe-basic-card>
  }
} @else {
  <ng-container *ngTemplateOutlet="steps" />
}
